var _defs, _rect, _g, _g2, _g3, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardBundle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgBundle",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f3d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#006437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bgBundle)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220 170)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -70,
    width: 92,
    height: 140,
    rx: 14,
    ry: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -56,
    width: 64,
    height: 92,
    rx: 4,
    ry: 4,
    fill: "#ffffff",
    opacity: 0.18,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360 180)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -42,
    width: 130,
    height: 84,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -26,
    width: 100,
    height: 14,
    fill: "#ffffff",
    opacity: 0.6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: 2,
    width: 60,
    height: 8,
    fill: "#ffffff",
    opacity: 0.4,
    stroke: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(490 210)",
    fill: "#ffffff",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -18,
    width: 52,
    height: 36,
    rx: 4,
    ry: 4,
    fill: "#ffffff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -16 -18 L -16 -28 L 16 -28 L 16 -18",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 26,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 2
  }, "DIGITAL + F\xCDSICA + FRETE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBundle);
export default __webpack_public_path__ + "static/media/card-bundle.9e6edea470f8c8d26300b7735614eb46.svg";
export { ForwardRef as ReactComponent };